<ik-info-box *ngIf="hasStudentCondition && isFree && total != 0" [iconClass]="'icon-warning warning icon-size-14'" [newBg]="true" class="margin-bottom-0">
    <span>{{ "La modification d'offre de votre produit entrainera la fin de votre offre étudiante" | transloco }}</span>
</ik-info-box>